import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import cookies from "js-cookie";
import { RootState } from "../../redux/store";

export interface ILanguageSlice {
  currentLanguageCode: string;
}

const initialState: ILanguageSlice = {
  currentLanguageCode: cookies.get("i18next") || "en",
};

export const languageAction = createSlice({
  name: "languageAction",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguageCode = action.payload;
    },
  },
});

export const { setLanguage } = languageAction.actions;

export const selectLanCode = (state: RootState) => state.languages.currentLanguageCode;

export default languageAction.reducer;